import type { FaireProductEntity } from "../../entity_types/product";

export const driftless_studios_17: FaireProductEntity = {
  token: "driftless-studios-17",
  type: "product",
  name: "20 oz Custom Mug Zip Code, City And State",
  brandName: "Driftless Studios",
  imageUrl:
    "https://cdn.faire.com/fastly/f768362f29ee10d99f5a9ce0efbe7179a179b27834f2566c55e2aabc62dfe781.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=960&width=720",
  priceDollars: 16.5,
  msrpDollars: 28,
  freeShipping: true,
  isBestseller: true,
  description: "",
  categoryTokens: ["cat_proto_home-and-living"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
